.internal-notes-container {
    width: 100%;
    height: 100%;
    padding: 16px;
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
}

.notes-section-container {
    position: relative;
    min-height: 100px;
    border: 1px solid var(--off-white-dk);
    border-radius: 3px;
    height: 100%;
}

.notes-section-container:focus-within {
    border-color: var(--blue);
}

.notes-section-container:hover:not(:focus-within) {
    border-color: var(--grey-lt);
}

.activity-type-and-leads-section-container {
    position: relative;
    z-index: 17; /* Above time selector */
    display: flex;
    gap: 32px;
    max-width: 100%;
}

.activity-type-and-leads-section-container > div {
    max-width: calc(50% - 21px); /* 50% - 16px (gap) - 5px (textField weirdness) */
}

.related-leads-section-container {
    width: 250px;
    height: fit-content;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.related-leads-list-empty-state {
    /* exact height of the related leads search, preventing jumping moving
    between states */
    height: 36.5px;
    box-sizing: border-box;
    align-content: center;
    padding: 8px;
    border-radius: 3px;
    background-color: var(--off-white);
}

.follow-up-banner {
    background-color: var(--blue-xlt);
    padding: 12px 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
    box-sizing: border-box;
}
